import { NgModule } from '@angular/core';
import { ExtraOptions, Router, RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './helpers/auth.guard';
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { ClientsComponent } from './components/clients/clients.component';
import { CandidatesComponent } from './components/candidates/candidates.component';
import { AdviceComponent } from './components/advice/advice.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { TermsOfUseComponent } from './components/policy/terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './components/policy/privacy-policy/privacy-policy.component';
import { FreedomOfInformationActComponent } from './components/policy/freedom-of-information-act/freedom-of-information-act.component';
import { ModernSlaveryActComponent } from './components/policy/modern-slavery-act/modern-slavery-act.component';
import { UnsubscribeSuccessfulComponent } from './components/unsubscribe-successful/unsubscribe-successful.component';
import { ConfirmPasswordComponent } from './components/confirm-password/confirm-password.component';
import { EmailConsentComponent } from './components/email-consent/email-consent.component';
import { CookieComponent } from './components/policy/cookies/cookies.component';
import { JobLatestComponent } from './components/job-latest/job-latest.component';
import { PrivacyNoticeComponent } from './components/privacy-notice/privacy-notice.component';
import { AcceptedTermsAndConditionsComponent } from './components/accepted-terms-and-conditions/accepted-terms-and-conditions.component';
import { AccessibilityStatementComponent } from './components/policy/accessibility-statement/accessibility-statement.component';
import { InfoHubComponent } from './components/info-hub/info-hub.component';
import { Config } from './app.config';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { authResolver } from './services/auth-resolver.service';
import { LoggedinGuard, LoggedinResolver } from './helpers/loggedIn.guard';


let routes: Routes = [];

const defaultRoutes: Routes = [
    {
        path: 'jobs',
        component: JobLatestComponent
    },
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'about',
        component: AboutComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'clients',
        component: ClientsComponent
    },
    {
        path: 'candidates',
        component: CandidatesComponent
    },
    {
        path: 'applications',
        component: ApplicationsComponent,
        resolve: { auth: authResolver },
        canActivate: [AuthGuard]
    },
    {
        path: 'advice',
        component: AdviceComponent
    },
    {
        path: 'terms-of-use',
        component: TermsOfUseComponent
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'privacy-notice',
        component: PrivacyNoticeComponent
    },
    {
        path: 'accepted-terms-and-conditions/:Guid',
        component: AcceptedTermsAndConditionsComponent
    },
    {
        path: 'cookie-policy',
        component: CookieComponent
    },
    {
        path: 'freedom-of-information-act',
        component: FreedomOfInformationActComponent
    },
    {
        path: 'accessibility-statement',
        component: AccessibilityStatementComponent
    },
    {
        path: 'modern-slavery-act',
        component: ModernSlaveryActComponent
    },
    {
        path: 'our-service',
        component: InfoHubComponent,
        resolve: { auth: authResolver },
        canActivate: [AuthGuard]
    }  ,
    {
        path: 'consent-confirmed/:token',
        component: EmailConsentComponent
    },
    {
        path: 'unsubscribe-successful/:token',
        component: UnsubscribeSuccessfulComponent
    },
    {
        path: 'confirm-password/:email/:token',
        component: ConfirmPasswordComponent,
        resolve: { auth: LoggedinResolver },
        canActivate: [LoggedinGuard]
    },
    {
        path: 'search',
        loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule)
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        resolve: { auth: authResolver },
        canActivateChild: [AuthGuard]
    },
    {
        path: 'account',
        loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
    },
    {
        path: 'advert-preview/:guid',
        loadChildren: () => import('./modules/job/job.module').then(m => m.JobsModule)
    },
    {
        path: 'job/:name/:id',
        loadChildren: () => import('./modules/job/job.module').then(m => m.JobsModule)
    },
    {
        path: 'saved-jobs',
        loadChildren: () => import('./modules/saved-jobs/saved-jobs.module').then(m => m.SavedJobsModule),
        resolve: { auth: authResolver },
        canActivateChild: [AuthGuard]
    },
    {
        path: 'apply/:name/:id',
        loadChildren: () => import('./modules/apply/apply.module').then(m => m.ApplyModule),
        resolve: { auth: authResolver },
        canActivateChild: [AuthGuard],
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'home'
    }
];

const accountTenantRoutes: Routes = [
    {
        path: 'home',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        component: DashboardComponent,
        resolve: { auth: authResolver },
        canActivate: [AuthGuard],
    },
    {
        path: 'jobs',

        component: JobLatestComponent
    },
    {
        path: 'about',
        component: AboutComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'clients',
        component: ClientsComponent
    },
    {
        path: 'candidates',
        component: CandidatesComponent
    },
    {
        path: 'applications',
        component: ApplicationsComponent,
        resolve: { auth: authResolver },
        canActivate: [AuthGuard]
    },
    {
        path: 'advice',
        component: AdviceComponent
    },
    {
        path: 'terms-of-use',
        component: TermsOfUseComponent
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'privacy-notice',
        component: PrivacyNoticeComponent
    },
    {
        path: 'accepted-terms-and-conditions/:Guid',
        component: AcceptedTermsAndConditionsComponent
    },
    {
        path: 'cookie-policy',
        component: CookieComponent
    },
    {
        path: 'freedom-of-information-act',
        component: FreedomOfInformationActComponent
    },
    {
        path: 'accessibility-statement',
        component: AccessibilityStatementComponent
    },
    {
        path: 'modern-slavery-act',
        component: ModernSlaveryActComponent
    },
    {
        path: 'our-service',
        component: InfoHubComponent,
        resolve: { auth: authResolver },
        canActivate: [AuthGuard]
    }  ,
    {
        path: 'consent-confirmed/:token',
        component: EmailConsentComponent
    },
    {
        path: 'unsubscribe-successful/:token',
        component: UnsubscribeSuccessfulComponent
    },
    {
        path: 'confirm-password/:email/:token',
        component: ConfirmPasswordComponent,
        resolve: { auth: LoggedinResolver },
        canActivate: [LoggedinGuard]
    },
    {
        path: 'search',
        loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule)
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        resolve: { auth: authResolver },
        canActivateChild: [AuthGuard]
    },
    {
        path: 'account',
        loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
    },
    {
        path: 'advert-preview/:guid',
        loadChildren: () => import('./modules/job/job.module').then(m => m.JobsModule)
    },
    {
        path: 'job/:name/:id',
        loadChildren: () => import('./modules/job/job.module').then(m => m.JobsModule)
    },
    {
        path: 'saved-jobs',
        loadChildren: () => import('./modules/saved-jobs/saved-jobs.module').then(m => m.SavedJobsModule),
        resolve: { auth: authResolver },
        canActivateChild: [AuthGuard]
    },
    {
        path: 'apply/:name/:id',
        loadChildren: () => import('./modules/apply/apply.module').then(m => m.ApplyModule),
        resolve: { auth: authResolver },
        canActivateChild: [AuthGuard],
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'home'
    }
];

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule {

    constructor(private http: HttpClient, private router: Router) {
        this.http.get('/assets/config.json').pipe(map((config: Config) => config?.accountMode))
            .subscribe({
                next: account => { account ?
                    routes = [...accountTenantRoutes] :
                    routes = [...defaultRoutes];
                    this.router.resetConfig(routes)
                },
                error: err => console.log("error loading routes", err)
            })
    }

}
